module.exports = __webpack_public_path__ + "img/logo-br.b707b95e.png";